module.exports = __webpack_public_path__ + "img/43.bb7ff647.png";